import { render, staticRenderFns } from "./TaskType.vue?vue&type=template&id=24bd1830&scoped=true"
import script from "./TaskType.vue?vue&type=script&lang=js"
export * from "./TaskType.vue?vue&type=script&lang=js"
import style0 from "./TaskType.vue?vue&type=style&index=0&id=24bd1830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bd1830",
  null
  
)

export default component.exports